import { ActionFrame, Anchor, Announcement01, Armchair, ArrowCircleBrokenRight, Atom01, Attachment01, Award01, Bank, BarChart12, Beaker02, Beer, BookOpen01, Brackets, Brain, Briefcase01, Building02, Building04, Building05, BuildingHome, BuildingHospital, Calculator, Calendar, CalendarCheck01, Camera01, Car01, CheckCircle, Clipboard, Clock, CodeBrowser, CodeSquare01, Columns03, Command, CreditCard01, Cube01, Cup, Database01, Dataflow01, Dataflow02, DocumentPile, DoubleQuotes, Download01, DownloadCloud02, Edit04, Eye, EyeOff, FaceHappy, File04, File06, FilePlus03, Film03, FilterLines, Fingerprint03, Fire, Flag01, Folder, FolderOpen, FolderPlus, GamingPad02, Globe01, GlobeSlated02, GraduationHat01, Hash02, Headphones01, Heart, HeartHand, Home02, Image01, Inbox01, LayersThree01, LayoutGrid02, Lightbulb01, LinkExternal01, List, ListSelect, Lock01, LogOut01, MagicWand02, Mail01, MailAi, MailClose, Map01, MarkerPin01, MarkPen, Maximize01, Menu01, MessageCircle01, MessageDotsCircle, MessageSmileCircle, Microphone01, Minimize01, Moon01, Paint, PieChart01, Pin02, PingPong, PlaneLand, PlaneTakeoff, Planet, Plus, PlusCircle, PresentationChart01, Printer, QrCode01, Rainbow, Robot, Rocket02, Route, Safe, Save01, Scales01, ScanFile, SearchMd, Seedling, Server03, ShakeHands, Shirt, ShoppingBag01, SlashCircle01, Speedometer03, Stars02, Sun, Sword, SyncCloud02, Tag01, TerminalSquare, ThumbsDown, ThumbsUp, Train, Translate01, Trash01, Trophy01, TShirt, Umbrella02, Upload01, UploadCloud02, User01, Users01, VideoRecorder, VolumeMax, VolumeNoise, XCircle, Youtube, } from "./v2-stroke";
/**
 * The selection of icons users can pick from to label skills in the product.
 *
 * Unlike every other icon module here, this one is hand-authored and is not
 * regenerated by `build_icons.sh`. The keys are not component names: they are
 * identifiers persisted in Postgres (`skill.icon`, `remote_mcp_server.icon`,
 * `webhook_sources_view.icon`) and frozen into the public SDK enum
 * `MCPInternalActionIconSchema`. Renaming or removing a key silently breaks
 * stored rows and the public API, so keys may only ever be added.
 *
 * The values are free to change — they were the retired filled `actions` set
 * and now point at v2-stroke. `resources_icons.tsx` in both `front` and
 * `marketing` asserts this object still covers every persisted name.
 */
export const ActionIcons = {
    ActionArmchairIcon: Armchair,
    ActionArrowDownOnSquareIcon: Download01,
    ActionArrowUpOnSquareIcon: Upload01,
    ActionAtomIcon: Atom01,
    ActionAttachmentIcon: Attachment01,
    ActionBankIcon: Bank,
    ActionBarcodeIcon: QrCode01,
    ActionBeerIcon: Beer,
    ActionBookOpenIcon: BookOpen01,
    ActionBracesIcon: Brackets,
    ActionBrainIcon: Brain,
    ActionBriefcaseIcon: Briefcase01,
    ActionBuildingIcon: Building05,
    ActionCalculatorIcon: Calculator,
    ActionCalendarCheckIcon: CalendarCheck01,
    ActionCalendarIcon: Calendar,
    ActionCameraIcon: Camera01,
    ActionCarIcon: Car01,
    ActionCardIcon: CreditCard01,
    ActionChatBubbleBottomCenterTextIcon: MessageCircle01,
    ActionChatBubbleThoughtIcon: MessageDotsCircle,
    ActionCheckCircleIcon: CheckCircle,
    ActionClipboardIcon: Clipboard,
    ActionCloudArrowDownIcon: DownloadCloud02,
    ActionCloudArrowLeftRightIcon: SyncCloud02,
    ActionCloudArrowUpIcon: UploadCloud02,
    ActionCodeBlockIcon: CodeBrowser,
    ActionCodeBoxIcon: CodeSquare01,
    ActionCommand1Icon: Command,
    ActionCommandIcon: TerminalSquare,
    ActionCommunityIcon: BuildingHome,
    ActionCompanyIcon: Building04,
    ActionCubeIcon: Cube01,
    ActionCupIcon: Cup,
    ActionCustomerServiceIcon: Headphones01,
    ActionDashboardIcon: Speedometer03,
    ActionDatabaseIcon: Database01,
    ActionDocumentIcon: File04,
    ActionDocumentPileIcon: DocumentPile,
    ActionDocumentPlusIcon: FilePlus03,
    ActionDocumentTextIcon: File06,
    ActionDoubleQuotesIcon: DoubleQuotes,
    ActionEmotionLaughIcon: FaceHappy,
    ActionExternalLinkIcon: LinkExternal01,
    ActionEyeIcon: Eye,
    ActionEyeSlashIcon: EyeOff,
    ActionFilmIcon: Film03,
    ActionFilterIcon: FilterLines,
    ActionFireIcon: Fire,
    ActionFlagIcon: Flag01,
    ActionFlightLandIcon: PlaneLand,
    ActionFlightTakeoffIcon: PlaneTakeoff,
    ActionFolderAddIcon: FolderPlus,
    ActionFolderIcon: Folder,
    ActionFolderOpenIcon: FolderOpen,
    ActionFrameIcon: ActionFrame,
    ActionFullscreenExitIcon: Minimize01,
    ActionFullscreenIcon: Maximize01,
    ActionGamepadIcon: GamingPad02,
    ActionGitBranchIcon: Dataflow02,
    ActionGitForkIcon: Dataflow01,
    ActionGlobeAltIcon: Globe01,
    ActionGlobeIcon: GlobeSlated02,
    ActionGraduationCapIcon: GraduationHat01,
    ActionHandHeartIcon: HeartHand,
    ActionHandThumbDownIcon: ThumbsDown,
    ActionHandThumbUpIcon: ThumbsUp,
    ActionHashtagIcon: Hash02,
    ActionHeartIcon: Heart,
    ActionHomeIcon: Home02,
    ActionHospitalIcon: BuildingHospital,
    ActionIdentityIcon: Fingerprint03,
    ActionImageIcon: Image01,
    ActionInboxIcon: Inbox01,
    ActionIncludeIcon: ArrowCircleBrokenRight,
    ActionLayoutIcon: Columns03,
    ActionLightbulbIcon: Lightbulb01,
    ActionListCheckIcon: ListSelect,
    ActionListIcon: List,
    ActionLockIcon: Lock01,
    ActionLogoutIcon: LogOut01,
    ActionMagicIcon: MagicWand02,
    ActionMagnifyingGlassIcon: SearchMd,
    ActionMailAiIcon: MailAi,
    ActionMailCloseIcon: MailClose,
    ActionMailIcon: Mail01,
    ActionMapIcon: Map01,
    ActionMapPinIcon: MarkerPin01,
    ActionMarkPenIcon: MarkPen,
    ActionMedalIcon: Award01,
    ActionMegaphoneIcon: Announcement01,
    ActionMenuIcon: Menu01,
    ActionMicIcon: Microphone01,
    ActionMoonIcon: Moon01,
    ActionMovieIcon: Youtube,
    ActionNoiseIcon: VolumeNoise,
    ActionNumbersIcon: BarChart12,
    ActionPaintIcon: Paint,
    ActionPencilSquareIcon: Edit04,
    ActionPieChartIcon: PieChart01,
    ActionPinDistanceIcon: Route,
    ActionPingPongIcon: PingPong,
    ActionPlanetIcon: Planet,
    ActionPlusCircleIcon: PlusCircle,
    ActionPlusIcon: Plus,
    ActionPrinterIcon: Printer,
    ActionPushpinIcon: Pin02,
    ActionRainbowIcon: Rainbow,
    ActionRobotIcon: Robot,
    ActionRocketIcon: Rocket02,
    ActionSafeIcon: Safe,
    ActionSaveIcon: Save01,
    ActionScalesIcon: Scales01,
    ActionScanIcon: ScanFile,
    ActionSeedlingIcon: Seedling,
    ActionServerIcon: Server03,
    ActionShakeHandsIcon: ShakeHands,
    ActionShipIcon: Anchor,
    ActionShirtIcon: Shirt,
    ActionShoppingBasketIcon: ShoppingBag01,
    ActionSlideshowIcon: PresentationChart01,
    ActionSparklesIcon: Stars02,
    ActionSpeakIcon: MessageSmileCircle,
    ActionSquare3Stack3DIcon: LayersThree01,
    ActionStopSignIcon: SlashCircle01,
    ActionStoreIcon: Building02,
    ActionSunIcon: Sun,
    ActionSwordIcon: Sword,
    ActionTableIcon: LayoutGrid02,
    ActionTagIcon: Tag01,
    ActionTestTubeIcon: Beaker02,
    ActionTimeIcon: Clock,
    ActionTrainIcon: Train,
    ActionTranslateIcon: Translate01,
    ActionTrashIcon: Trash01,
    ActionTrophyIcon: Trophy01,
    ActionTShirtIcon: TShirt,
    ActionUmbrellaIcon: Umbrella02,
    ActionUserGroupIcon: Users01,
    ActionUserIcon: User01,
    ActionVidiconIcon: VideoRecorder,
    ActionVolumeUpIcon: VolumeMax,
    ActionXCircleIcon: XCircle,
};
//# sourceMappingURL=ActionIcons.js.map